import React from 'react';
import { testimonials } from '../data/testimonials';

/** Inclinazione e spostamento di ogni messaggio, per l'effetto "pila". */
const stackStyles = ['-rotate-2 -translate-x-2 sm:-translate-x-8', 'rotate-[1.5deg] translate-x-2 sm:translate-x-8', '-rotate-1 -translate-x-1 sm:-translate-x-4'];

/** Tre messaggi in stile chat, impilati e leggermente inclinati uno sotto
 *  l'altro: si leggono tutti scorrendo, senza swipe laterale. */
export function TestimonialsSection() {
  return <section className="w-full overflow-hidden bg-paper py-10 sm:py-14" aria-labelledby="testimonials-heading" data-id="element-204" data-mp="1i0o2vetdjoqz">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-205" data-mp="141oco2q7r1sp">
        <h2 id="testimonials-heading" className="text-center font-display text-2xl font-bold uppercase leading-tight text-pine sm:text-3xl" data-id="element-206" data-mp="14399jz002wtq">
          Cosa ci scrivono gli allenatori
        </h2>

        <ul className="mx-auto mt-7 flex max-w-md flex-col" aria-label="Recensioni" data-id="element-207" data-mp="2yd34qq6p5dbm">
          {testimonials.map((item, cardIndex) => <li key={item.name} className={`relative flex flex-col overflow-hidden rounded-2xl border border-line bg-paper-deep shadow-lg shadow-ink/10 ${stackStyles[cardIndex % stackStyles.length]} ${cardIndex > 0 ? '-mt-2' : ''}`} style={{
          zIndex: cardIndex + 1
        }} data-id="element-208" data-mp="2v1kr0lzjg5up" data-mpi={cardIndex}>
              <div className="flex items-center gap-3 bg-pine px-4 py-3" data-id="element-209" data-mp="34t8bg2xogmmo">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-paper-soft font-display text-sm font-bold text-pine" aria-hidden="true" data-id="element-210" data-mp="2zt2t5ddasch9">
                  {item.initials}
                </span>
                <span className="min-w-0" data-id="element-211" data-mp="2m0wc7p2bm1gr">
                  <span className="block truncate font-sans text-sm font-semibold text-paper-soft" data-id="element-212" data-mp="2m1xm3q7lohww">
                    {item.name}
                  </span>
                  <span className="block truncate font-sans text-xs text-pine-light" data-id="element-213" data-mp="1ane9s08dl8g">
                    {item.role}
                  </span>
                </span>
              </div>

              <blockquote className="flex flex-1 flex-col gap-1.5 p-3.5" data-id="element-214" data-mp="3sjb1yely1kj6">
                {item.messages.map((message, index) => <p key={message} className={`max-w-[92%] rounded-xl bg-paper-soft px-3 py-2 font-sans text-sm leading-snug text-ink shadow-sm ${index === 0 ? 'rounded-tl-sm' : ''}`} data-id="element-215" data-mp="8dvc4j3sbfeh" data-mpi={index}>
                    {message}
                    {index === item.messages.length - 1 ? <span className="ml-2 inline-block translate-y-0.5 font-sans text-[10px] text-ink-muted" data-id="element-216" data-mp="ibj81cd4msy8">
                        {item.time}
                      </span> : null}
                  </p>)}
              </blockquote>
            </li>)}
        </ul>
      </div>
    </section>;
}